import React, { useState, useEffect, createContext, useCallback } from "react";
import { playlistsAPI } from "../services/supabaseClient";

export const FAVOURITES_PLAYLIST_ID = "favourites";
export const TOP_SONGS_PLAYLIST_ID = "top-songs";

export const CurrentPlaylistContext = createContext();

export const CurrentPlaylistProvider = ({ children }) => {
  const [currentPlaylist, setCurrentPlaylist] = useState(
    localStorage.getItem("currentPlaylist") === FAVOURITES_PLAYLIST_ID
      ? FAVOURITES_PLAYLIST_ID
      : parseInt(localStorage.getItem("currentPlaylist")) || null
  );
  const [currentVideoIndex, setCurrentVideoIndex] = useState(
    parseInt(localStorage.getItem("currentVideoIndex")) || 0
  );
  const [artists, setArtists] = useState([]);
  const [videos, setVideos] = useState([]);
  const [isErrorLoadingDB, setIsErrorLoadingDB] = useState(false);
  const [isLoadingDB, setIsLoadingDB] = useState(true);

  // Active (playing) state - tracks what's actually playing in the YouTube player
  const [activePlaylist, setActivePlaylist] = useState(null);
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  const [activeVideos, setActiveVideos] = useState([]);

  const setSearchVideoByID = (playlist_id, id) => {
    if (currentPlaylist === null) return;
    const fetchData = async () => {
      try {
        const data = await playlistsAPI.getVideos(playlist_id);
        setVideos(data);
        const video = data.find((video) => video.id === id);
        const videoIndex = data.indexOf(video);
        setCurrentPlaylist(playlist_id);
        setCurrentVideoIndex(videoIndex);
        // Also start playing the searched song
        setActivePlaylist(playlist_id);
        setActiveVideoIndex(videoIndex);
        setActiveVideos(data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  };

  const searchVideo = (playlist, video) => {
    setSearchVideoByID(playlist, video);
  };

  // Allow setting videos directly (used for favourites playlist)
  const setVideosDirectly = useCallback((vids) => {
    setVideos(vids);
  }, []);

  // Start playing: sync active state from current browsing state
  const startPlaying = useCallback((playlistId, videoIndex, vids) => {
    setActivePlaylist(playlistId);
    setActiveVideoIndex(videoIndex);
    setActiveVideos(vids);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await Promise.race([
          playlistsAPI.getAll(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("timeout")), 5000)
          ),
        ]);
        setArtists(data);
        setIsLoadingDB(false);
      } catch (error) {
        setIsErrorLoadingDB(true);
        console.error("Error fetching data: ", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (currentPlaylist === null || currentPlaylist === FAVOURITES_PLAYLIST_ID || currentPlaylist === TOP_SONGS_PLAYLIST_ID) return;
    const fetchData = async () => {
      try {
        const data = await playlistsAPI.getVideos(currentPlaylist);
        setVideos(data);
      } catch (error) {
        console.error("Error fetching videos: ", error);
      }
    };

    fetchData();
  }, [currentPlaylist]);

  useEffect(() => {
    localStorage.setItem("currentPlaylist", currentPlaylist);
    localStorage.setItem("currentVideoIndex", currentVideoIndex);
  }, [currentPlaylist, currentVideoIndex]);

  return (
    <CurrentPlaylistContext.Provider
      value={{
        currentPlaylist,
        setCurrentPlaylist,
        currentVideoIndex,
        setCurrentVideoIndex,
        searchVideo,
        artists,
        videos,
        setVideosDirectly,
        isLoadingDB,
        isErrorLoadingDB,
        activePlaylist,
        setActivePlaylist,
        activeVideoIndex,
        setActiveVideoIndex,
        activeVideos,
        setActiveVideos,
        startPlaying,
      }}
    >
      {children}
    </CurrentPlaylistContext.Provider>
  );
};

export default CurrentPlaylistContext;

